import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { titleCase, TOAST_DURATION, TOAST_ERROR_COLOR, TOAST_POSITION, TOAST_SUCCESS_COLOR } from "../../../../common/app_constant";
// import Blog from "../../../../component/blog";
import CompanyList from "../../../../component/company_list";
import ErrorLabel from "../../../../component/error_label";
import Newsletter from "../../../../component/newsletter";
import OurApp from "../../../../component/our_app";
import RecommendedPolicy from "../../../../component/recommended_policy";
import { actionGetClaim, resetGetClaimResponse } from "../claim/store";
import { actionGetPolicyDashboard, actionGetPolicyInactive, resetGetPolicyInactiveResponse, resetGetPolicyResponse } from "../dashboard/store";
import CompanyListModal from "./company_list";
import { actionAllContactPerson, actionChangePassword, actionClientDetails, actionClientList, actionKYCDocumentsDelete, actionKYCDocumentsDownload, actionProfileEdit, resetChangePasswordResponse, resetClientDetailsResponse, resetClientListResponse, resetContactPersonResponse, resetKYCDocumentsDownloadeResponse, resetProfileEditResponse } from "./store";
import UploadDocuments from "./upload_doc";
import _ from 'lodash';
import Swal from "sweetalert2";
import { SUB_DIRECTORY } from "../../../../common/constant";
import Loader from "../../../../component/page_loader";
import Contact from "../../../../component/contact";
import { actionGetAppointments, resetGetAppointmentsResponse } from "../appointments/store";
import $ from 'jquery'

const MyProfile = () => {

    const dispatch = useDispatch()
    const navigation = useNavigate()
    const[myProfile,setMyProfile]=useState(null)
    const { contactPerson, clientList, clientDetails, KYCDocumentsDownload, KYCDocumentsDelete, changePassword, profileEdit } = useSelector((state) => ({
        ...state.MyProfileStore
    }))

    const { getClaim } = useSelector((state) => ({
        ...state.claimStore
    }))

    const { getPolicy, getPolicyInactive } = useSelector((state) => ({
        ...state.dashboardStore
    }))

    const { getAppointments } = useSelector((state) => ({
        ...state.appointmentsStore
    }))

    const {
        register,
        formState: { errors },
        handleSubmit,
        getValues,
        setValue,
        watch,
        clearErrors,
        control
    } = useForm({
        defaultValues: {
            is_active: false,
            is_my_profile: false,
            profileObj: null,
            isDisplayCompany: false,
            isUploadDoc: false,
            client: {
                group_name: '',
                pan: '',
                website: '',
                address: '',
                mobile: '',
                pincode: '',
                contact_name: '',
                contact_designation: '',
                contact_phone: '',
                contact_email: '',
                gst: ''
            },
            getAllPolicy: [],
            getAllPolicyInactive: [],
        },
    });

    const { register: register2, setValue: setValue2,
        handleSubmit: handleSubmit2,
        clearErrors: clearErrors2,
        watch: watch2,
        reset: reset2,
        formState: { errors: errors2 } } = useForm({

        })


    const getAllPolicy = watch('getAllPolicy')
    const getAllPolicyInactive = watch('getAllPolicyInactive')
    const [claim, setClaim] = useState([])

    const password = useRef({});
    password.current = watch2("new_password", "");
    const isMyProfile = watch('is_my_profile')
    const isDisplayCompany = watch('isDisplayCompany')
    const isUploadDoc = watch('isUploadDoc')

    const [contactPersonArr, setContactPersonArr] = useState([])
    const [clientListArr, setClientList] = useState([])

    const [companySelectedItem, setCompanySelectedItem] = useState(null)
    const [clientObj, setClientObj] = useState(null)
    const [isLoader, setLoader] = useState(false)
    const [appointments, setAppointments] = useState([])
    const [passwordShown, setPasswordShown] = useState(false);
    const [newPasswordShown, setNewPasswordShown] = useState(false);
    const [confirmPasswordShown, setConfirmPasswordShown] = useState(false);

    const togglePasswordVisiblity = () => {
        setPasswordShown(passwordShown ? false : true);
    };

    const toggleNewPasswordVisiblity = () => {
        setNewPasswordShown(newPasswordShown ? false : true);
    };

    const toggleConfirmPasswordVisiblity = () => {
        setConfirmPasswordShown(confirmPasswordShown ? false : true);
    };

    const renderFirstletter = (item) => {
        const str = item
        const str2 = str?.charAt(0)
        return str2?.toUpperCase()
    }

    const initialRender = () => {
        const userDataString = localStorage.getItem("userData");
        if (userDataString) {
          const userData = JSON.parse(userDataString);
            setMyProfile(userData)
        }
      };
      useEffect(() => {
        initialRender();
      }, []);

    return (
        <>
            <div className="row pb-5 mt-6">
                <div className="col-12">
              
                      <h5 className="mb-0"> My Profile</h5> 
                             
                </div>
                <div className="col-12 col-md-8">
                    {
                        isLoader === true ?
                            <Loader />
                            :
                            <>
                               
                                <div>
                                   
                                    <div className="mt-4">
                                        <div className="accordion" >
                                            <div className="accordion-item">
                                                <h2 className="accordion-header">
                                                    <div className="d-flex">
                                                        <div className="col-10">
                                                            <div
                                                                className="accordion-button-2 collapsed"
                                                                type="button"
                                                                data-bs-toggle="collapse"
                                                                data-bs-target="#panelsStayOpen-collapseOne"
                                                                aria-expanded="false"
                                                                aria-controls="panelsStayOpen-collapseOne"
                                                            >
                                                                Profile :&nbsp;&nbsp;<b>{titleCase(myProfile?.full_name)}</b>
                                                            </div>
                                                        </div>                                                
                                                    </div>
                                                </h2>
                                                <div
                                                    id="panelsStayOpen-collapseOne"
                                                    className="accordion-collapse collapse show border-top"
                                                    aria-labelledby="panelsStayOpen-headingOne"
                                                >
                                                    <div className="accordion-body">

                                                            

                                                                <div className="row">
                                                                    {/* <div className="col-md-4">
                                                                        <label htmlFor="title" className="col-form-label">
                                                                            Group Name
                                                                        </label>
                                                                        <p>{_.capitalize(myProfile?.group_name)}</p>
                                                                    </div> */}
                                                                    <div className="col-md-4">
                                                                        <label htmlFor="fullName" className="col-form-label">
                                                                            Company Name
                                                                        </label>
                                                                        <p>AXIS BANK</p>
                                                                        {/* <p>{_.capitalize(myProfile?.corporateDetail?.name)}</p> */}

                                                                    </div>
                                                                    <div className="col-md-4">
                                                                        <label htmlFor="email" className="col-form-label">
                                                                            Email
                                                                        </label>
                                                                        <p>{myProfile?.email} </p>
                                                                    </div>
                                                                    <div className="col-md-4">
                                                                        <label htmlFor="mblNo" className="col-form-label">
                                                                            Mobile No.
                                                                        </label>

                                                                        <p>{myProfile?.mobile} </p>

                                                                    </div>
                                                                    {/* <div className="col-md-4">
                                                                        <label htmlFor="panNo" className="col-form-label">
                                                                            PAN No.
                                                                        </label>
                                                                        <p>{myProfile?.pan ? myProfile?.pan : "-"} </p>
                                                                    </div>
                                                                    <div className="col-md-4">
                                                                        <label htmlFor="aadharNo" className="col-form-label">
                                                                            Website
                                                                        </label>
                                                                        <p>{myProfile?.website ? myProfile?.website : "-"} </p>

                                                                    </div>
                                                                    <div className="col-md-4">
                                                                        <label htmlFor="pincode" className="col-form-label">
                                                                            Pincode
                                                                        </label>

                                                                        <p>{myProfile?.pincode ? myProfile?.pincode : "-"} </p>
                                                                    </div>
                                                                    <div className="col-8">
                                                                        <label htmlFor="address" className="col-form-label">
                                                                            Address
                                                                        </label>
                                                                        <p>{myProfile?.communication_address ? myProfile?.communication_address : "-"} </p>
                                                                    </div> */}
                                                                </div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                        </div>
                                    </div>
                                    {/* END: Contact person details */}
                                </div>
                            </>


                    }
                </div>
                <div className="col-12 col-md-4">
                    {/* <RecommendedPolicy /> */}
                    {/* <div className="card profile-section mb-3">
                        <div class="card-body d-flex">
                            <div class="profile-container col-3">
                                <div class="initial-text">
                                    <span> {renderFirstletter(clientObj?.group_name)}</span>
                                </div>
                            </div>
                            <div class="ms-3 my-auto col-9">
                                <h5 className="mb-1">{titleCase(clientObj?.group_name)}</h5>
                            </div>
                        </div>
                    </div> */}
                    <Contact/>
                    {/* <CompanyList
                        data={clientListArr}
                        selectedItem={companySelectedItem}
                        onSelect={(data) => {
                            if (data != null) {
                                setCompanySelectedItem(data)
                            }
                        }}

                    /> */}
                    {/* <Newsletter /> */}
                    {/* <Blog /> */}
                </div>
            </div>
            {/* <CompanyListModal
                isDisplayCompany={isDisplayCompany}
                companyList={clientListArr}
                selectedItem={companySelectedItem}
                isDisplayCompanyClose={(data) => {
                    setCompanySelectedItem(data)
                    setValue('isDisplayCompany', false)
                }}
            /> */}

            <UploadDocuments
                isUploadDoc={isUploadDoc}
                selectedItem={companySelectedItem}
                isUploadDocClose={() => {
                    setValue('isUploadDoc', false)
                    // dispatch(actionClientDetails({ client_id: companySelectedItem }))

                }}
            />

        </>


    )

}

export default MyProfile;